import { writable } from 'svelte/store';
import collect from 'collect.js';
// Constants
import config from '@/config';
// Models
import RacingMultiLegEvent from '@/Models/RacingMultiLegEvent';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getForMeeting(meetingId, betTypeId) {
			if (!config.RACING_ENABLED) return;

			const multiLegEvent = new RacingMultiLegEvent();
			multiLegEvent.resourceUrl = () => {
				return `${multiLegEvent.baseUrl()}/meetings/${meetingId}/multi_leg_events`;
			};
			return multiLegEvent
				.where('bet_type_id', betTypeId)
				.get()
				.then((result) => {
					set(result.data);

					return result;
				});
		},

		saveManualResults(meetingId, data) {
			if (!config.RACING_ENABLED) return;

			const multiLegEvent = new RacingMultiLegEvent();

			return multiLegEvent.makePersistRequest({
				url: `${multiLegEvent.baseUrl()}/meetings/${meetingId}/multi_leg_events/results`,
				method: 'POST',
				data: data
			});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
